export default {
  data: () => ({
    provinces: [],
    counties: [],
    communes: []
  }),
  methods: {
    changedWojewodztwo() {
      this.getPRG("counties");
      if (!this.disableResetLocalization) {
        this.updateProperty("localization", "powiat", null);
        this.updateProperty("localization", "gmina", null);
      }
    },
    changedPowiat() {
      this.getPRG("communes");
      if (!this.disableResetLocalization) {
        this.updateProperty("localization", "gmina", null);
      }
    },
    getPRG(level) {
      let woj, pow;
      try {
        woj = this.provinces.find(
          prov =>
            this.attributes.localization.find(
              attr => attr.name === "wojewodztwo"
            ).value === prov.jpt_nazwa_
        ).jpt_kod_je;
      } catch {
        woj = null;
      }
      try {
        pow = this.counties.find(
          county =>
            this.attributes.localization
              .find(attr => attr.name === "powiat")
              .value.toLowerCase() === county.jpt_nazwa_.toLowerCase()
        ).jpt_kod_je;
      } catch {
        pow = null;
      }
      const payload = {
        level,
        params: {
          woj,
          pow
        }
      };
      this.$store.dispatch("getPRG", payload).then(r => {
        if (r.status === 200) {
          this[level] = r.data[level];
        }
      });
    },
    filterByPRG(level, entitiesArray) {
      if (this[level]) {
        const { jpt_nazwa_ } = this[level];
        return entitiesArray.filter(p => {
          return p[level] === jpt_nazwa_;
        });
      }
      return entitiesArray;
    }
  },
  mounted() {
    this.$store
      .dispatch("getPRG", {
        level: "provinces"
      })
      .then(r => {
        this.provinces = r.data.provinces;
      });
  }
};
